import script from "./Collapse.vue?vue&type=script&setup=true&lang=js"
export * from "./Collapse.vue?vue&type=script&setup=true&lang=js"

import "./Collapse.vue?vue&type=style&index=0&id=2dbb003c&lang=css"

const __exports__ = script;

export default __exports__